var React = require('react');

function Destroyer (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Destroyer"),React.createElement("g",{"id":"g1425","key":2},[React.createElement("path",{"id":"path877-6","className":"cls-1","d":"M114,79,64,29,14,79Z","key":0}),React.createElement("path",{"id":"path879-7","className":"cls-1","d":"M14,99H114","key":1})])]);
}

Destroyer.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Destroyer;

Destroyer.default = Destroyer;
